// MerchantSignup.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Signup.css'; // reuse styles
import { FaArrowLeft } from 'react-icons/fa';
import API_BASE_URL from './config';

const MerchantSignup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    businessName: '',
    ownerName: '',
    email: '',
    mobile: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/merchant/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.ok) {
        localStorage.setItem("merchantId", result.merchantId);
        alert('Merchant signup successful!');
        navigate('/merchant-login');
      } else {
        alert(result.message || 'Signup failed!');
      }
    } catch (err) {
      console.error('Merchant signup error:', err);
      alert('Server error during merchant signup.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-card">
        <button className="back-btn" onClick={() => navigate('/merchant-login')} disabled={loading}>
          <FaArrowLeft />
        </button>
        <h2>Register as a Merchant</h2>
        <form onSubmit={handleSubmit}>
          <label>Business Name</label>
          <input type="text" name="businessName" value={formData.businessName} onChange={handleChange} required />

          <label>Owner Name</label>
          <input type="text" name="ownerName" value={formData.ownerName} onChange={handleChange} required />

          <label>Email</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />

          <label>Mobile</label>
          <input type="tel" name="mobile" value={formData.mobile} onChange={handleChange} required />

          <label>Password</label>
          <input type="password" name="password" value={formData.password} onChange={handleChange} required />

          <button type="submit" disabled={loading}>{loading ? 'Registering...' : 'Sign Up as Merchant'}</button>
        </form>
      </div>
    </div>
  );
};

export default MerchantSignup;
